class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    const closeButton = this.querySelector('.modal__close-button') || this.querySelector('button[type="button"]');
    closeButton?.addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    const initialInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
    const shouldPreserveHeaderSearchScroll = this.classList.contains('header__search') && initialInput;
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      initialInput
    );

    if (shouldPreserveHeaderSearchScroll) {
      requestAnimationFrame(() => {
        initialInput.focus({ preventScroll: true });
        window.scrollTo(scrollX, scrollY);
      });
    }
  }

  resetHeaderSearch() {
    if (!this.classList.contains('header__search')) return;

    this.querySelectorAll('predictive-search').forEach((predictiveSearch) => {
      if (typeof predictiveSearch.close === 'function') {
        predictiveSearch.close(true);
        return;
      }

      const input = predictiveSearch.querySelector('input[type="search"]');
      const results = predictiveSearch.querySelector('[data-predictive-search]');

      if (input) {
        input.value = '';
        input.setAttribute('aria-expanded', false);
        input.setAttribute('aria-activedescendant', '');
      }

      if (results) results.innerHTML = '';
      predictiveSearch.querySelector('button[type="reset"]')?.classList.add('hidden');
      predictiveSearch.removeAttribute('loading');
      predictiveSearch.removeAttribute('open');
      predictiveSearch.removeAttribute('results');
    });
  }

  close(focusToggle = true) {
    this.resetHeaderSearch();
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
